import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <h2>{t("footer.companyName")}</h2>
          <p>{t("footer.tagline")}</p>
        </div>

        <div className="footer-links">
          <h3>{t("footer.quickLinks")}</h3>
          <ul>
            <li><a href="/">{t("footer.home")}</a></li>
            <li><a href="/services">{t("footer.services")}</a></li>
            <li><a href="/contact">{t("footer.contact")}</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <h3>{t("footer.companyInfo")}</h3>
          <ul>
            <li>{t("footer.orgNumber")}: 559547-0740</li>
            <li><a href="tel:087455557">08-74-555-57</a></li>
            <li><a href="tel:+46737637460">+46-73-763-7460</a></li>
            <li><a href="mailto:info@crigotechnologies.com">info@crigotechnologies.com</a></li>
          </ul>
        </div>

        <div className="footer-social">
          <h3>{t("footer.followUs")}</h3>
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/company/crigo-technologies/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/crigotechnologies?igsh=MXJqMTR2eTdhZGZkOQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {t("footer.copyright")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;